import { useLocation } from "react-router-dom";
import { usePunditUserContext } from "@/react/contexts";
import { settingsNavPathV3 } from "../helpers/urlHelpers";
import { useExperimentEnabled } from "./experiments/useExperimentEnabled";
import { useMediaQuery, useTailwindMdScreenMediaQuery } from "./useMediaQuery";
import { useUrlParamEnabled } from "./utils/useUrlParamEnabled";

export const usePlanPageVariant = () => {
  const { experimentation } = usePunditUserContext();
  const experimentFlagData = experimentation?.flags?.plans_page_variant_c_test;
  const variantCFlag =
    typeof experimentFlagData === "object"
      ? experimentFlagData?.type
      : undefined;

  const { pathname } = useLocation();
  const isMdScreenOrLarger = useTailwindMdScreenMediaQuery();
  const canShowSummaryLayout = useMediaQuery("(max-width: 1200px)");

  const isExperimentEnabled =
    useExperimentEnabled("plans_page_variant_c_test") && isMdScreenOrLarger;

  const isVariantC1flagEnabled =
    isExperimentEnabled && variantCFlag === "variant_c1";
  const isVariantC2flagEnabled =
    isExperimentEnabled && variantCFlag === "variant_c2";

  const isVariantC1Enabled =
    useUrlParamEnabled("variant_c1") || isVariantC1flagEnabled;
  const isVariantC2Enabled =
    useUrlParamEnabled("variant_c2") || isVariantC2flagEnabled;
  const isExperimentLayoutEnabled = isVariantC1Enabled || isVariantC2Enabled;

  const isExperimentTabLayout =
    isExperimentLayoutEnabled && isMdScreenOrLarger && canShowSummaryLayout;

  const isPlansPageLayout = [
    settingsNavPathV3.plans.general,
    settingsNavPathV3.plans.billing,
    settingsNavPathV3.plans.brandedApps,
  ].some(path => pathname.includes(path));

  return {
    isPlansPageLayout, // Defines if the plan page layout is enabled (without sidebar)
    isVariantC1Enabled,
    isVariantC2Enabled,
    isExperimentLayoutEnabled,
    isExperimentTabLayout,
  };
};
